'use strict';

import HighestBid from './components/HighestBid.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('highest-bid', HighestBid);

    }
}